
const PaObjectSorter = (a, b) => {

    if (!a) return -1
    //if (!b) return +1
    //console.log("sorting!!!", a, b, a.localeCompare(b, 'en-US', {numeric: "true", sensitivity: 'base'}))
    return a.localeCompare(b, 'en-US', {numeric: "true", sensitivity: 'base'})
}

export default PaObjectSorter